// extracted by mini-css-extract-plugin
module.exports = {"container":"swipeable_container__2BNID","slidershow":"swipeable_slidershow__2yVYM"};